import React from 'react'
import Hero from '../components/Hero'

import Terminal from '../components/Terminal'
import HorizontalLine from '../components/HorizontalLine'


const Home = () => {
  return (
    <>
    <Hero />
    {/* <div className='z-50 w-screen h-screen'> */}

    {/* </div> */}
    <HorizontalLine />
    <Terminal />


    </>
  )
}

export default Home